import { List, RecordOf } from 'immutable';
import { createSelector } from 'reselect';
import { DefaultCharge, Tax } from 'services/resources';
import { RootState } from 'store';

const selectFleetSettingsState = () => (state: RecordOf<RootState>) => state.get('fleetSettings');

export const selectFleetSettings = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('settings'));

export const selectAlerts = () => createSelector(selectFleetSettingsState(), (substate) => substate.get('alerts'));

export const selectTermsAndConditions = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('termsAndConditions'));

export const selectCharges = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('charges') as List<RecordOf<DefaultCharge>>);

export const selectChargeById = (id: number) =>
  createSelector(selectFleetSettingsState(), (substate) => {
    const charges = substate.get('charges');
    return charges.filter((charge) => charge.id === id);
  });

export const selectDefaultCharges = () =>
  createSelector(
    selectFleetSettingsState(),
    (substate) => substate.get('defaultCharges') as List<RecordOf<DefaultCharge>>
  );

export const selectTaxes = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('taxes') as List<RecordOf<Tax>>);

export const selectChargesErrors = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('chargesErrors'));

export const selectTaxesErrors = () =>
  createSelector(selectFleetSettingsState(), (substate) => substate.get('taxesErrors'));

export const selectLoading = () => createSelector(selectFleetSettingsState(), (substate) => substate.get('loading'));

export const selectErrors = () => createSelector(selectFleetSettingsState(), (substate) => substate.get('errors'));

export const selectDevices = () => createSelector(selectFleetSettingsState(), (substate) => substate.get('devices'));
